// src/features/users/hooks/useUserPermissions.ts

import { usePermissions } from 'react-admin';
import { User } from '../types';

export const useUserPermissions = (user?: User) => {
  const { permissions: role } = usePermissions<User['role']>();

  const canViewUsers = role && ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canCreateUsers = role && ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canEditUsers = canCreateUsers;
  const canDeleteUsers = canCreateUsers;

  const canEditThisUser = (targetUser?: User): boolean => {
    const u = targetUser || user;
    if (!role || !u) return false;

    switch (role) {
      case 'SuperAdmin':
        return u.role !== 'SuperAdmin'; // Un SuperAdmin no puede editar a otro
      case 'GroupAdmin':
        // Puede editar usuarios de su grupo, pero no a otros admins
        const userGroupId = localStorage.getItem('groupId');
        return u.groupId === userGroupId && u.role !== 'SuperAdmin' && u.role !== 'GroupAdmin';
      case 'HotelAdmin':
        // Puede editar usuarios de su hotel, pero no a otros admins
        const userHotelId = localStorage.getItem('hotelId');
        return u.hotelId === userHotelId && u.role === 'Receptionist';
      default:
        return false;
    }
  };
  
  const canDeleteThisUser = (targetUser?: User): boolean => {
      // La lógica suele ser la misma que para editar
      return canEditThisUser(targetUser);
  };

  return {
    currentUserRole: role,
    canViewUsers,
    canCreateUsers,
    canEditUsers,
    canDeleteUsers,
    canEditThisUser,
    canDeleteThisUser,
  };
};